export default __webpack_public_path__ + "static/media/Icon23.69046ce7.svg";